<!--UploadFile-->
<template>
	<div class="question-container" style="border: 1px solid #edeff2">
		<div class="question-type">上传文件</div>
		<div class="title-view" :style="{ marginRight: '' }">
			<p style="color: #4c4a56">
				<span v-if="dataObj.isMust === 1" class="asterisk">*</span>
				{{ `${index + 1}、` }}
				<span style="color: #4c4a56">
					{{ dataObj.caseProblem }}
					<span v-if="dataObj.pictureNum" class="pictureNum">
						（仅限上传{{ dataObj.pictureNum }}个文件)
					</span>
				</span>
			</p>
		</div>

		<div class="question-images">
			<div v-for="(item, index) in images" :key="index" style="margin-top: 10px; position: relative">
				<img :src="item" mode="widthFix" style="width: 100%" />
			</div>
		</div>

		<div class="upload-file">
			<div class="button">
				<img class="icon" src="https://ossfastmake.mustke.com/qrCode/tupian/1761100444730.svg" />
				上传文件
			</div>
			<div class="text">支持word、excel、ppt、pdf格式上传</div>

			<div v-if="answerList.length > 0" class="file-list">
				<div v-for="(item, idx) in answerList" :key="idx" class="file-item">
					<div class="east">
						<img class="icon" src="https://ossfastmake.mustke.com/qrCode/tupian/1762401082820.svg"></img>
						<span>{{ item.name }}</span>
					</div>
					<img class="del" @click="deleteFile(index)" src="https://ossfastmake.mustke.com/qrCode/tupian/1761120250640.svg" mode=""></img>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			params: {
				type: Object,
				default: {},
			},
		},
		data() {
			return {
				dataObj: {},
				index: 0,
				images: [],
				list: [],
				answerList: [],
			};
		},
		watch: {
			params: {
				handler(newVal) {
					this.dataObj = newVal.data;
					this.index = newVal.index;
					this.images = JSON.parse(newVal.data.caseProblemImg || '[]');
					this.list = JSON.parse(newVal.data.chooseList || '{"list":[]}').list;

					if (newVal.answer && Array.isArray(newVal.answer.answer)) {
						this.answerList = newVal.answer.answer.map(a => ({
							name: a.name || '',
						}));
					} else {
						this.answerList = [];
					}
				},
				deep: true,
				immediate: true,
			},
		},
	};
</script>

<style scoped>
	.upload-file {
		margin: 10px 0;
	}

	.upload-file .button {
		background: #3a60ff;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
		font-size: 14px;
		color: #fff;
		font-weight: 600;
		margin-top: 10px;
		height: 39px;
	}

	.upload-file .button .icon {
		width: 17px;
		height: 17px;
	}

	.upload-file .text {
		font-size: 12px;
		color: #2b2f36;
		margin: 10px 0;
		text-align: center;
	}

	.upload-file .pictureNum {
		font-size: 13px;
		color: #4c4a56;
	}

	.file-list {
		margin-top: 10px;
	}

	.file-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.file-item .east {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		gap: 8.5px;
	}
	
	.file-item .icon {
		width: 24px;
		height: 21px;
		flex: none;
	}
		
	.file-item span {
		display: inline-block;
		vertical-align: middle;
		font-size: 14px;
		color: #333;
	}
		
	.file-item .del {
		width: 16px;
		height: 16px;
	}
		
	.file-item+.file-item {
		margin-top: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewUploadFile.vue